module.exports = __webpack_public_path__ + "static/media/loading.d2106070.svg";